import EventTabEnum from '../../enum/eventTabEnum';
import React, { FC } from 'react';
import { IConferenceSpeaker } from '../../event/eventInterface';
import { Typography, Avatar } from '@getgo/chameleon-web/react';
import { SpeakerUtils } from '../../utils/speakerUtils';

export interface ConferenceSpeakerProps {
  speaker: IConferenceSpeaker;
  handleEventSpeakerChange?: (index: number, speakerId: string) => void;
}

const ConferenceSpeaker: FC<ConferenceSpeakerProps> = ({ speaker, handleEventSpeakerChange }) => (
  <div
    className="conference-speaker"
    key={speaker.id}
    onClick={() => handleEventSpeakerChange?.(EventTabEnum.Speakers, speaker.id)}
  >
    <div className="conference-avatar">
      {speaker.imgsrc ? (
        <Avatar size="xsmall">
          <img alt={speaker.name} src={speaker.imgsrc} />
        </Avatar>
      ) : (
        <Avatar size="xsmall">{SpeakerUtils.getInitials(speaker.name)}</Avatar>
      )}
    </div>
    <div className="conference-speaker-text">
      <Typography color="text-01">{speaker.name}</Typography>
    </div>
  </div>
);

export default ConferenceSpeaker;
